import React from 'react';

const CategoryContent = ({ name, isDragging = false }) => (
    <div className={`p-4 bg-gray-100 rounded-lg ${isDragging ? 'opacity-50' : ''}`}>
        <h2 className="text-xl font-bold mb-2">{name}</h2>
    </div>
);

export default CategoryContent;
